var Interface = function() {};

Interface.prototype = {
    // Shorthand Use of Prototype
    constructor : Interface,

    // Add Loaded Class On DOM Ready
    interfaceReady : function(loadedClass){
        var loadedClass = loadedClass || 'loaded';
        $('body').addClass('loaded');
    },

    // Toggle Class On Body
    toggleStatus : function(statusClass, scope){
        var statusClass = statusClass || '',
            scope = scope || 'html';

        $(scope).toggleClass(statusClass);
    },

    // Hide/Show Target Element
    toggleContent : function(selector){
        var target = $(selector).attr('href') || $(selector).attr('data-content-toggle');

        $(target).toggleClass('hide-content');
    },

    // Toggle Tabbed Content
    toggleTabbedContent : function(selector, parent){
        var target = $(selector).attr('href') || $(selector).attr('data-content-toggle'),
            targetParent = parent || '.js-tab';
        var targetContainer = $(selector).closest('[data-content-toggle-container]').attr('data-content-toggle-container');

        $(targetContainer + "> .toggle-content")
            .removeClass("fade-in-content")
            .addClass("hide-content");
        $(target, targetContainer)
            .removeClass("hide-content");
        // NOTE: we have to add a delay after un-hiding the content to allow the animation to work
        setTimeout(() => {
            $(target, targetContainer)
                .addClass("fade-in-content");
        }, 10);

        $('.js-tab').not('.active-tab').each(function() {
            var _id = $(this).find('.js-tab-link').attr('href');
            if (_id && _id.length) {
                $(_id).find('.ui-message:not(.ui-message-permanent)').remove();
            }
        });

        //BEGIN fix for nested tabs
        //var targetSelector = $(selector).closest('[data-content-toggle-container]').attr('data-content-toggle-container');
        //var targetContainer = $(selector).closest('[data-content-toggle-container]').siblings(targetSelector);

        //$(targetContainer).children('.toggle-content').removeClass('fade-in-content').addClass('hide-content');
        //$(targetContainer).children(target).removeClass('hide-content').addClass('fade-in-content');
        //END fix for nested tabs

        //added for active tab link toggle-content
        $(selector).closest(targetParent).addClass('active-tab').siblings().removeClass('active-tab');
    },

    setupTabs : {
        standard : function(selector, parent) {
            var target = selector || '.js-tab-link',
                targetParent = parent || '.js-tab';

            UI.toggleTabbedContent( target, targetParent + ':first' );

            $( target ).on('click', function(e) {
                e.preventDefault();

                UI.toggleTabbedContent( $(this), targetParent );
            });
        },

        hashTabs : function(selector, parent) {
            var target = selector || '.js-tab-link',
                targetParent = parent || '.js-tab';
            // Set Up Tabs
            if ( window.location.hash ) {
                var hashValue = window.location.hash.replace(/^#tab-/, ''),
                    element = $('a[href="#' + hashValue + '"]');

                if ( element.length ) {
                    UI.toggleTabbedContent( element );
                } else {
                    UI.toggleTabbedContent( target, targetParent + ':first');
                }
            } else {
                var tabLink = $( target ).attr( 'href' )
                if ( typeof tabLink !== 'undefined' && tabLink.length > 0 ) {
                    var hashValue = tabLink.replace( /^#/, '' );
                    UI.toggleTabbedContent( target + ':first', targetParent );
                    window.location.hash = 'tab-' + hashValue;
                } else {
                    UI.toggleTabbedContent( target, targetParent + ':first');
                }
            }

            $( target ).on('click', function(e) {
                var hashValue = $(this).attr('href').replace(/^#/, '');

                e.preventDefault();
                UI.toggleTabbedContent($(this), targetParent);
                window.location.hash = 'tab-' + hashValue;
            });
        }
    },

    // Format phone numbers based on country
    formatPhone: function () {
        // if the formatter plugin is available, format the phone numbers
        if (typeof $.fn.formatter !== 'undefined'){
            $('.format-phone-number').each(function(){
                var format = $(this).attr('data-format') || '({{999}}) {{999}}-{{9999}}';

                $(this).formatter({
                    'pattern': format,
                    'persistent': false
                });
            });

            $('.format-any-phone-number').formatter({
                'patterns': [
                    {'^[0-9]{1,10}$' : '({{999}}) {{999}}-{{9999}}'},
                    {'*' : '{{***************}}'}
                ],
                'persistent': false
            }).on('keyup', function(){
                var length = $(this).val().replace(/\(|\)| |\-/g, '').length;

                if ( length > 10 ){
                    $(this).removeClass('validatePhone');
                } else {
                    $(this).addClass('validatePhone');
                }
            });
        }
    },

    // Slide Target Element Down/Up
    slideToggleContent : function(selector, speed, callback){
        var target = $(selector).attr('href') || $(selector).attr('data-content-toggle'),
            speed = speed || 400,
            callback = callback || null;

        $(target).slideToggle(speed, function(){
            if ( $(target).css('overflow') == "hidden" ){
                $(target).css('overflow', 'visible');
            }

            if( $.isFunction(callback) ){
                callback.call( this );
            }
        });
    },

    // Render Custom Select Elements
    renderCustomSelect : function(selector, forceRender){
        var selector = selector || '.ui-select',
            forceRender = forceRender || false,
            className = selector.split('.').join(''),
            supportedClasses = ['hide-content', 'appearance-simple'];

        if( Modernizr.testAllProps('appearance') || forceRender ){
            // we can force rendering, but we should only add this class if the CSS Appearance property is supported
            if ( Modernizr.testAllProps('appearance') ) {
                $('html').addClass('cssappearance');
            }

            $(selector).each(function(){
                var element = $(this);

                if ( ! element.parent().is('.ui-select-container') ){ // prevent re-rendering button
                    element.wrap('<span class="ui-select-container"></span>');
                }

                $(supportedClasses).each(function(index, value){
                    if ( element.hasClass(value) ){
                        element.removeClass(value);
                        element.parent().addClass(value);
                    }
                });

                $(this).closest('.field-container').addClass('select-field');
            });
        }
    },

    /**
     * @function asyncSelect
     * @param {string} [selector] CSS selector for select element(s)
     * @param {string} [containerSelector] CSS selector for select element(s) container. This is the container with the data attributes used to build the post data.
     * @param {function} [successCallback] Function called when qpost responds with a success message.
     * @description Adds necessary event listeners for async select. Used in conjunction with asyncSelect twig macro.
     */
    asyncSelect : function ( selector, containerSelector, successCallback ) {
        var elementSelector = selector || '.js-async-select';
        var dataContainer = containerSelector || '.js-async-select-container';
        var $selectElement = $( elementSelector );

        $selectElement.on( 'focus', function ( e ) {
            var $select = $( this );
            if ( $select.is( '.is-loading' ) ) {
                e.preventDefault();
                return;
            }
            // Store data for persisting selected option before server response
            $select.data( 'qg_last_selected', $select.find( 'option:selected' ) );
        });

        // "verified" select handling
        $selectElement.on( 'change', function () {
            var $select = $( this );
            var $dataContainer = $select.closest( dataContainer );
            var postData = $dataContainer.data();
            var endLoadingState = function () {
                $select.removeClass( 'is-loading' );
                $select.siblings( '.js-loading-dots' ).addClass( 'hide-content' );
            };

            // add action to post data
            postData[ 'action' ] = $select.find( 'option:selected' ).val();

            Message.remove();

            // persist the previous selected option;
            $select.data( 'qg_last_selected' ).prop( 'selected', true );

            // stop here if processing
            if ( $select.is( '.is-loading' ) ) {
                return;
            }

            // start loading state.
            $select.addClass( 'is-loading' );
            $select.siblings( '.js-loading-dots' ).removeClass( 'hide-content' );

            // handle updating of "verified"
            $.fn.qpost( {
                url : postData.url,
                data : postData,
                success : function ( data ) {
                    if ( data.success ) {
                        // update the value of the select
                        $select.val( postData.action );

                        if ( successCallback ) {
                            successCallback.call( $select, data );
                        }
                    } else {
                        Message.post( 'We were unable to change the status of this transaction. Please try later.', 'error' );
                    }
                },
                failure : function () {
                    Message.post( 'We were unable to change the status of this transaction. Please try later.', 'error' );
                }
            } )
                .always( function () {
                    endLoadingState();
                } );
        });
    },

    // Init Options Toggle
    bindOptionsToggle : function(selector){
        var selector = selector || '.ui-options-toggle';
        $(selector).on('click', function(){
            $(this).closest('.ui-options-dropdown').toggleClass('active');
        });
    },

    // Hide Element on Clickout
    bindClickOut : function(selector, callback){
        var callback = callback || function(){};

        $('html').on('mousedown', function(e) {
            var $target = $(e.target);

            if( ! $target.closest(selector).length ){
                callback.call(undefined, selector);
                $(this).off('mousedown');
            }
        });
    },

    // Get An Element's Data Attributes
    getDataAttributes : function(el){
        var attributes = '';

        if( el.length ) {
            $.each( el[0].attributes, function( i, attr ) {
                if( attr.name.substr(0,5) =='data-' )
                    attributes += attr.name + '="' + attr.value + '" ';
            } );
        }
        return attributes;
    },

    // Select Input Contents On Focus
    selectOnFocus : function(selector){
        var selector = selector || '.select-on-focus';

        $(selector).on('click', function(e){
            $(this).select();
            e.preventDefault();
        });
    },

    // Focus Field on Page Load
    focusOnLoad : function(selector){
        var selector = selector || '.focus-on-load';
        setTimeout(function(){ $(selector + ':first').focus() }, 300);
    },

    // Auto Advance Field
    autoAdvance : function(selector){
        var selector = selector || '.auto-advance-field';

        $(selector).each(function(){
            var valueMaxLength = $(this).attr('maxlength'),
                inputs = $('body').find('button, input, textarea, select'),
                inputIndex = inputs.index(this);

            $(this).on('keyup', function(e) {
                if ( e.keyCode != 9 & e.keyCode != 16 ){
                    var valueLength = $(this).val().length;
                    if ( valueLength >= valueMaxLength ){
                        inputs.eq(inputIndex + 1).focus();
                    }
                }
            });

        });
    },

    // Faux Placeholder Using Labels
    toggleInlineLabel : function(selector, scope){
        var selector = selector || '.label-is-placeholder .form-field',
            scope = scope || document;

        $(scope).on('keyup blur input', selector, function() {
            if ($(this).val()) {
                $(this).closest('.field-container').addClass('has-value');
            } else {
                $(this).closest('.field-container').removeClass('has-value');
            }
        });

        $(selector).trigger('blur');
    },

    // interface enhancements for payment
    paymentValidation : function(selector, inputSelector, callback){
        var selector = selector || '#payment-card-number',
            inputSelector = inputSelector || '#payment-type-credit-card',
            callback = callback || function(){};

        // Show inactive payment options while typing
        $(selector).on('keyup blur', function(){
            var cardType = QGIV.Payment.getCardType($(this).val(), true),
                creditCardOption = $(inputSelector).closest('.field-label');

            if ( cardType ) {
                if( ! $(inputSelector).prop('checked') ){
                    $(inputSelector).prop('checked', true);
                }

                $(creditCardOption).find('.ui-payment-option').removeClass('inactive');
                $(creditCardOption).find('.ui-payment-option:not(.type-' + cardType + ')').addClass('inactive');
            } else {
                $(creditCardOption).find('.ui-payment-option').removeClass('inactive');
            }
        });
    },

    // Scroll The Page To A Target Element
    scrollToElement : function(selector, speed, scope, offset){
        var scrollTarget = $(selector),
            speed = speed || 500
            scope = scope || 'html, body',
            offset = offset || 0;

        $(scope).animate({
            scrollTop: scrollTarget.offset().top - offset
        }, speed);
    },

    // Sticky Sidebar
    stickySidebar : function(selector, options){
        var defaults = {
            scrollTimer         : null,
            scrollTimeout       : 25,
            scrollOffset        : 30,
            resizeTimer         : null,
            resizeTimeout       : 100,
            resizeBreakpoint    : 768,
            isDesktop           : false
        };

        var _sticky = this.stickySidebar,
            settings = $.extend({}, defaults, options),
            stickyElement = $(selector) || '.ui-sticky-element',
            stickyElementWidth = stickyElement.width(),
            stickyElementPosition = stickyElement.offset(),
            topOffset = stickyElementPosition.top + settings.scrollOffset;

        var init = function(){
            bindResize();

            checkScreenWidth();

            bindScroll();
        },
        checkScreenWidth = function(){
            if ( $(window).width() >= settings.resizeBreakpoint ){
                settings.isDesktop = true;
            } else{
                settings.isDesktop = false;
            }
            updateElementWidth();
        },
        updateElementWidth = function(){
            stickyElement.width('auto');
            stickyElementWidth = stickyElement.width();
        },
        bindResize = function(){
            $(window).resize(function(){
                if( settings.resizeTimer ){
                    clearTimeout( settings.resizeTimer );
                }
                settings.resizeTimer = setTimeout(checkScreenWidth, settings.resizeTimeout);
            });
        },
        bindScroll = function(){
            $(window).scroll(function(){
                if ( settings.isDesktop ){
                    if( settings.scrollTimer ){
                        clearTimeout( settings.scrollTimer );
                    }
                    settings.scrollTimer = setTimeout(stickElement, settings.scrollTimeout);
                }
            });
        },
        stickElement = function(){
            settings.scrollTimer = null;
            var scrollPosition = $(window).scrollTop();

            if( scrollPosition > topOffset ){
                stickyElementPosition = stickyElement.offset();

                stickyElement.addClass('fix-element');
                stickyElement.css({
                    'width' : stickyElementWidth,
                    'top' : settings.scrollOffset + 'px'
                });
            } else{
                stickyElement.removeClass('fix-element');
            }
        };

        init();
    },

    // Replace File Extensions
    replaceExtension : function(el, ext, replacement){
        var source = el.attr('src'),
            sourceExtension = source.split('.').pop();

        if ( sourceExtension == ext ){
            var newSource = source.replace('.' + ext, '.' + replacement);
            el.attr('src', newSource);
        }
    },

    // Support SVG Files
    supportSVG : function(selector){
        var selector = selector || '.support-svg';
        var _this = this;

        if( $('html').hasClass('no-svg') ){
            $(selector).each(function(){
                _this.replaceExtension($(this), 'svg', 'png');
            });
        }
    },

    // Support Custom SVG Files (uploaded to Cloud Files)
    supportCustomSVG : function(selector){
        var selector = selector || '.support-custom-svg';

        if( $('html').hasClass('no-svg') ){
            $(selector).each(function(){
                var fallbackSRC = $(this).attr('data-fallback-src');
                $(this).attr('src', fallbackSRC);
            });
        }
    },

    // Support object-fit css property
    supportObjectFit: function(selector){
        if ( !Modernizr.objectfit ) {
            $(selector).each(function(){
                var $container = $(this);
                var imgUrl = $container.find('img').attr('src');

                if (imgUrl) {
                    $container
                        .css('backgroundImage', 'url(' + imgUrl + ')')
                        .addClass('compat-object-fit');
                }
            });
        }
    },

    // Enable Print Page Functionality
    enablePrintPage : function(selector){
        var _this = this;
        var selector = selector || '.button-print-page';

        $(selector).on('click', function(e){
            var _url = $(this).attr('href');

            if ( $(this).attr('data-target') ){
                var target = $(this).attr('data-target'),
                    contents = $(target).html();

                var printWindow = window.open(_url, '', 'width=800,height=600,toolbar=no,location=no,menubar=no,status=no');
                _this.printContent = contents;
            } else {
                window.print();
            }
            e.preventDefault();
        });
    },

    // store the print content
    printContent : '',

    // Open New Window via Javascript (ex: social sharing)
    openWindow : function(selector, title, options){
        var defaults = {
            'toolbar'    : 'no',
            'location'   : 'no',
            'status'     : 'no',
            'menubar'    : 'no',
            'scrollbars' : 'yes',
            'resizable'  : 'yes',
            'width'      : '600',
            'height'     : '450'
        };

        var selector = selector || '.social-sharing-popup',
            title = title || '',
            settings = $.extend({}, options, defaults);

        var windowOptions = '';

        $.each(settings, function(key, value){
            if( value.length && windowOptions.length === 0 ){
                windowOptions += key + '=' + value;
            } else if ( value.length ){
                windowOptions += ',' + key + '=' + value;
            }
        });

        $(selector).on('click', function(e){
            var targetURL = $(this).attr('href');

            window.open(targetURL, title, windowOptions);

            e.preventDefault();
            e.stopPropagation();
        });
    },

    // Add Vendor JS
    vendor : {
        twitter: function(callback){
            var callback = callback || function(){};
            if ( ! window.twttr ){
                $.getScript('//platform.twitter.com/widgets.js', callback);
            } else {
                twttr.widgets.load();
            }
        },
        facebook: function(callback, appID){
            var callback = callback || function(){},
                fbAppID = appID || '139246682755300';

            $.getScript('//connect.facebook.net/en_US/sdk.js', function(){
                // init facebook
                FB.init({
                    appId      : fbAppID,
                    cookie     : true,  // enable cookies to allow the server to access the session
                    xfbml      : true,  // parse social plugins on this page
                    version    : 'v2.5' // use version 2.4
                });

                // run callback function
                callback.call(undefined);
            });
        }
    },

    /**
     * @function clipboard
     * @description Sets up click listener that copies the value of the
     *      data-clipboard-text attribute to the clipboard
     * @param {string} [copyHtml] HTML string temporarily used to replace the
     *      inner HTML of the clicked element.
     */
    clipboard: function (
        copyHtml = 'Copied <i class="far fa-clipboard-check"></i>'
    ) {
        $('.js-copy-text').on('click', function (e) {
            const $clicked = $(this);
            const originalHtml = $clicked.html();

            e.preventDefault();

            navigator.clipboard.writeText($clicked.attr('data-clipboard-text'));

            $clicked
                .css('min-width', this.getBoundingClientRect().width)
                .html(copyHtml);

            // remove the popout after 2.5 seconds
            setTimeout(() => {
                $clicked.css('min-width', '').html(originalHtml);
            }, 2500);
        });
    },

    /**
     * @function clipboardTooltip
     * @description Sets up click listener that copies the value of the
     *      data-clipboard-text attribute to the clipboard
     * @param {string} [copyText] String temporarily used to replace the
     *      value of the data-tooltip attribute
     */
    clipboardTooltip: function (copyText = 'Copied') {
        $('.js-copy-text-tooltip').on('click', function (e) {
            const $clicked = $(this);
            const originalAriaLabel = $clicked.attr('aria-label');
            const originalTooltipText = $clicked.attr('data-tooltip');

            e.preventDefault();

            $clicked.attr({
                'aria-label': copyText,
                'data-tooltip': copyText,
            });

            navigator.clipboard.writeText($clicked.attr('data-clipboard-text'));

            // revert the tooltip text after 2.5 seconds
            setTimeout(() => {
                $clicked.attr({
                    'aria-label': originalAriaLabel,
                    'data-tooltip': originalTooltipText,
                });
            }, 2500);
        });
    },

    // Clear Values / Delselect Inputs
    clearFields: function (fields) {
        var textInputs = fields.not(':checkbox, :radio, :button, :submit, :reset, select, .form-reset-link'),
            chkRdioInputs = fields.filter(':checkbox, :radio'),
            selectInputs = fields.filter('select');

        textInputs.val('').text('');
        chkRdioInputs.prop('checked', false);
        selectInputs.find('option:selected').prop('selected', false).trigger('chosen:updated');

        fields.each(function(){
            var defaultValue = $(this).attr('data-orig-value');
            if ( typeof defaultValue !== 'undefined' && defaultValue.length > 0 ) $(this).val(defaultValue).trigger('change').trigger('chosen:updated');
        });

        // Some inputs need 'change' to be triggered
        chkRdioInputs.filter('.ui-numeric-toggle-unlimited').trigger('change');
    },

    // Clear Error Messages JS
    clearErrors: function (fields) {
        fields.filter('.has-error')
            .removeClass('has-error')
            .closest('.field-container').find('.field-message').remove();
    },

    // Loop through visible form fields and reveal error messages for empty fields
    // $container should be the same container you call $.fn.validate on
    showEmptyErrors: function ( $container ) {
        var $fields = $container.find('input:visible, select:visible, textarea:visible, .validateMultiCheckboxEmpty'),
            $chosenEls = $('.chosen-container:visible'),
            formValidationData = $container.data('qg_validation'),
            validationClasses = formValidationData ? formValidationData.settings.validationClass : null,
            errors = [];

        // Add chosen elements before we check if $fields
        // is populated in case there are only chosen selects
        $chosenEls.each(function() {
            var $select = $(this).prev('select');

            $fields = $fields.add( $select );
        });

        // Stop if we don't have what we need
        if ( ! $fields || ! validationClasses ) return;

        $fields.each(function(i, el) {
            var _class = $(this).attr('class'),
                hasError = false;

            if ( typeof _class !== typeof undefined && _class !== false ) {
                var c = _class.split(' ');

                // Loop through the array of class names
                for (var i = 0, l = c.length; i < l; ++i) {
                    // If one of the class names is a validation class then proceed
                    if ( ('.' + c[i] === validationClasses.empty || '.' + c[i] === validationClasses.emptySelect || '.' + c[i] === validationClasses.emptyRadio || '.' + c[i] === validationClasses.emptyMultiCheckbox) && ! hasError ){
                        $(this).trigger('blur');

                        // Check if 'blur' led do an error message
                        var errorMessage = $(this).closest(formValidationData.settings.fieldWrapper).find('.' + formValidationData.settings.errorClass).text();

                        if ( errorMessage.length ){
                            errors.push(errorMessage);
                        }

                        hasError = true;
                    }
                }
            }
        });
    },

    checkBoxSelect : function() {
        if ( $('.select-deselect-all').length || $('.checkbox-select').length ) {
            var lastChecked;

            $('.select-deselect-all').on('change', function() {
                var chkBoxName = $(this).attr('data-target');

                if ( $(this).prop('checked') ) {
                    $(this).addClass('is-selected');
                    $('[name="' + chkBoxName + '"]:visible').filter(':enabled').prop('checked', true).addClass('auto-selected').trigger('change');
                } else {
                    $(this).removeClass('is-selected');
                    $('[name="' + chkBoxName + '"]').prop('checked', false).removeClass('auto-selected').trigger('change');
                }
            });

            // Deselect the Toggle if unchecking an option
            $('tbody').on('click', '.auto-selected', function() {
                var parent = $(this).closest('.data-table');

                parent.find('.select-deselect-all').prop('indeterminate', true).removeClass('is-selected');
            });

            // Add Shift/Click for multiselect
            $('tbody').on('click', '.checkbox-select', function( evt ) {
                var chkBoxName = $(this).attr('name'),
                    $chkBoxes = $('input[name="' + chkBoxName + '"]');

                if( !lastChecked ) {
                    lastChecked = this;
                    return;
                }

                if( evt.shiftKey ) {
                    var start = $chkBoxes.index(this),
                        end = $chkBoxes.index(lastChecked);

                    $chkBoxes.slice(Math.min(start, end), Math.max(start, end) + 1)
                        .filter(':visible')
                        .filter(':enabled')
                        .prop('checked', lastChecked.checked)
                        .trigger('change');
                }
                lastChecked = this;
            });
        }
    },

    showAllContent : function(callback) {
        $('.show-all').on('click', function(e) {
            var $parent = $(this).closest('.show-all-container');

            e.preventDefault();

            $parent.toggleClass('expanded');

            if ( $parent.hasClass('expanded') ) {
                $(this).text('Show Less');
            } else {
                $(this).text('Show All');
            }

            if( $.isFunction(callback) ){
                callback.call( this );
            }
        });
    },

    // wrapper for ajax callbacks
    ajax : {
        callback : function(){},
        init : function(){
            // we should do some basic interface stuff
            UI.renderCustomSelect();

            // init AutoNumeric
            if ( $('.currency-input').length ) {
                $('.currency-input').each(function(){
                    AutoNumericNumber('#' + $(this).attr('id'));
                });
            }
            if ( $('.percentage-format').length ) {
                $('.percentage-format').each(function(){
                    AutoNumericNumber('#' + $(this).attr('id'));
                });
            }
            if ( $('.decimal-percentage-format').length ) {
                $('.decimal-percentage-format').each(function(){
                    AutoNumericNumber('#' + $(this).attr('id'));
                });
            }

            // calling custom events
            this.callback.call(this);
        }
    },

    // ckeditor options
    ckeditor : {
        verybasic : [
            [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ],
            [ 'Link', 'Unlink' ]
        ],
        basic : [
            [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ],
            [ 'NumberedList', 'BulletedList', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
            [ 'Link', 'Unlink' ]
        ],
        standard : [
            [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ],
            [ 'Link', 'Unlink' ],
            [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
            [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ]
        ],
        full : [
            [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ],
            [ 'Find', 'Replace', '-', 'SelectAll', '-', 'Scayt' ],
            [ 'Link', 'Unlink' ],
            '/',
            [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ],
            [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'],
            '/',
            [ 'Format', 'FontSize' ],
            [ 'TextColor', 'BGColor' ],
            [ 'Source' ]
        ],
        textFormatting : [
            [ 'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat' ],
            [ 'Link', 'Unlink' ],
            [ 'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
            [ 'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo' ],
            '/',
            [ 'Format', 'FontSize' ],
            [ 'TextColor', 'BGColor' ]
        ],
        insertTagsOnly : [
            ['strinsert']
        ],
        mobileFriendly : [
            [ 'Bold', 'Italic', 'Underline', '-', 'RemoveFormat' ],
            [ 'BulletedList'],
            [ 'TextColor', 'BGColor' ]
        ],
        temp_setting : {}, // use this to pass temporary values between editor plugins / UI elements
        tag_settings : {}, // an array of content tags passed for rich combo editors - use objects with ckeditor instance id
        block_settings : {} // an array of content blocks passed for rich combo editors - use objects with ckeditor instance id
    },

    postPreviews : {
        init: function() {
            // Facebook URL preview
            if ( $('.sharing-facebook').length ) {
                $('.sharing-facebook .preview-url-select').each(function() {
                    var scope = $(this).attr('data-target-parent') || '.post-preview';

                    if ( $(scope).find('.ui-media, .no-media-content').hasClass('hide-content') ) {
                        var targetURL = $(this).find('option:selected').attr('data-preview-url');
                        UI.postPreviews.setPreviewURL( $(this) );
                        UI.postPreviews.updateMediaPreview(scope, targetURL);
                    }
                });

                $('.sharing-facebook .preview-url-select').on('change', function () {
                    var targetURL = $(this).find('option:selected').attr('data-preview-url'),
                        scope = $(this).attr('data-target-parent');

                    UI.postPreviews.setPreviewURL( $(this) );
                    UI.postPreviews.updateMediaPreview(scope, targetURL);
                });
            }

            // Twitter URL preview
            if ( $('.sharing-twitter').length > 0 ) {
                // Used on Hobnob front-end screens
                $('.create-new-post').on('click', function () {
                    if ($('#post-name').val() != '' || $('#post-message').val() != '') {
                        $('.clear-form').trigger('click');
                    }
                });

                // Global
                $('.sharing-twitter .preview-url-select').each(function() {
                    UI.postPreviews.setPreviewURL( $(this) );
                });

                $('.sharing-twitter .preview-url-select').on('change', function () {
                    UI.postPreviews.setPreviewURL( $(this) );
                });
            }

            // Post previews
            if ($('.preview-trigger').length) {
                $('.preview-trigger').on('change keyup', function() {
                    var target = $(this).attr('data-preview-target'),
                        previewText = $(this).attr('data-preview-default') || '',
                        charCount = $(this).val().length;
                    //activate the preview once a user starts typing
                    if(charCount >= 1){
                        $(target).removeClass('inactive');
                        $(target).find('.preview-text').html($(this).val());
                    } else {
                        $(target).addClass('inactive');
                        $(target).find('.preview-text').html(previewText);
                    }

                    //for twitter we need a character count and to append the site URL into the tweet
                    if($(target).hasClass('has-character-count')){
                        var charLimit = $(target).find('.preview-text').attr('data-char-limit'),
                            siteURL = $(target).find('.site-url').text().length,
                            charRemaining = charLimit - charCount - 22, //siteURL was used before, but twitter automatically makes any link 22 characters
                            counter = $(target + '+ .char-count span');
                        //set maxlength attr
                        $(this).attr('maxlength', (charLimit - siteURL));
                        //add character counter
                        if(counter.length != 1){
                            $(target).after('<p class="char-count static-content text-right"><span></span></p>');
                        }
                        //update the character count
                        counter.text(charRemaining + ' characters remaining');
                        //warning color when the count is low
                        if(charRemaining <= 10){
                            counter.addClass('ui-text-error-color');
                        } else {
                            counter.removeClass('ui-text-error-color');
                        }
                    }
                });
                //trigger keyup on change if the form was reset
                $('.preview-trigger').on('change', function() { $(this).trigger('keyup'); });
            }
        },

        //update the URL that appears in the FB and Twitter post previews
        setPreviewURL : function( elem ) {
            var scope = elem.attr('data-target-parent') || '.post-preview',
                targetURL = $('#baseURL').val();
                targetURL += elem.find('option:selected').attr('data-preview-url');

            $( scope ).find('.site-url').text(targetURL);
        },

        //update for the Facebook Site Preview
        updateMediaPreview : function (scope, targetURL) {
            var scope = scope || '.post-preview';

            $.ajax({
              url: targetURL,
              type: "GET",
              dataType: 'html',
              success: function (response) {
                    var siteName = $(response).filter('meta[property="og:site_name"]').attr('content'),
                        siteImg = $(response).filter('meta[property="og:image"]').attr('content'),
                        siteDesc = $(response).filter('meta[property="og:description"]').attr('content');

                    //if none of the variables have values then there is no preview available
                    if(!siteName && !siteImg && !siteDesc) {
                        noPreview( scope );
                    }

                    //if any one of these are true then show the preview
                    if(siteName || siteImg || siteDesc) {
                        $( scope ).find('.media-preview .ui-media').removeClass('hide-content');
                        $( scope ).find('.no-media-content').addClass('hide-content');
                    }

                    //set the site info if it's there
                    if(siteName == '') {
                        var siteName = $(response).filter('title').text();
                    }
                    $( scope ).find('.media-site-name').text(siteName);

                    if(siteImg == '') {
                        $( scope ).find('.media-preview .ui-media .media-image').addClass('hide-content');
                    } else {
                        $( scope ).find('.media-preview .ui-media .media-image').removeClass('hide-content').find('img').attr('src', siteImg);
                    }

                    if(siteDesc == '') {
                        $( scope ).find('.media-site-description').addClass('hide-content');
                    } else {
                        $( scope ).find('.media-site-description').text(siteDesc).removeClass('hide-content');
                    }
                },
                error: function () {
                  noPreview( scope );
                }
            });

            function noPreview(scope) {
                $( scope ).find('.media-preview .ui-media').addClass('hide-content');
                $( scope ).find('.no-media-content').removeClass('hide-content');
            }
        }
    },

    // event throttling
    throttle : function(callback, delay, scope, throttleEvent){
        var callback = callback || function(){},
            delay = delay || 500,
            scope = scope || window,
            throttleEvent = throttleEvent || 'resize';

        var resizeTimer = null;

        $(scope).on(throttleEvent, function(){
            if ( typeof resizeTimer !== 'undefined' ){
                clearTimeout(resizeTimer);
            }

            resizeTimer = setTimeout(function(){
                callback.call(undefined);
            }, delay);
        });
    },

    // match font sizes
    matchFontSizes : function(selector, callback, maxSize){
        var $elements = $(selector),
            baseSize = 0,
            sizesAreEqual = true,
            fontSizes = [],
            callback = callback || function(){},
            maxSize = maxSize || 36;

        Array.min = function(array){
            return Math.min.apply(Math, array);
        };

        //$elements.removeAttr('style');
        $elements.each(function(index, element){
            var fontSize = parseInt($(this).css('font-size'));

            // if we've already used this function and added styles, remove them
            $(this).css('font-size', '');

            // on the first loop set the base size
            if ( index == 0 ) baseSize = fontSize;

            // on preceding loops
            if ( index > 0 ){
                // check if the current font size does not equal base size
                if ( fontSize !== baseSize ){
                    sizesAreEqual = false;
                }
                // set the new size
                baseSize = fontSize;
            }

            // add the fontsize to the stack
            fontSizes.push(fontSize);
        });

        if ( ! sizesAreEqual ){
            var smallestFont = Array.min(fontSizes);
            if ( smallestFont > maxSize ) smallestFont = maxSize;

            $elements.css('font-size', smallestFont + 'px');

            callback.call(undefined);
        } else {
            callback.call(undefined);
        }
    },

    // check if a hex color is light
    isLightColor : function(hex){
        var r = parseInt(hex.substr(0,2),16),
            g = parseInt(hex.substr(2,2),16),
            b = parseInt(hex.substr(4,2),16);

        var yiq = ((r*299)+(g*587)+(b*114))/1000;

        return (yiq >= 128) ? true : false;
    },

    // method to lighten or darken a color
    lightenDarkenColor : function(color, amount){
        var usePound = false;

        if (color[0] == "#") {
            color = color.slice(1);
            usePound = true;
        }

        var num = parseInt(color, 16);

        var r = (num >> 16) + amount;

        if (r > 255){
            r = 255;
        } else if (r < 0){
            r = 0;
        }

        var b = ((num >> 8) & 0x00FF) + amount;

        if (b > 255){
            b = 255;
        } else if (b < 0){
            b = 0;
        }

        var g = (num & 0x0000FF) + amount;

        if (g > 255){
            g = 255;
        } else if (g < 0){
            g = 0;
        }

        return ( usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
    },

    truncate : function(selector, charLimit, afterText){
        $(selector).each(function() {
            var elText = $(this).text(),
                afterText = afterText || '...';

            var shortText = elText.trim() // Remove leading and trailing spaces
                .substring(0, charLimit) // Get the right number of characters
                .split(" ") // Separate characters into an array of words
                .slice(0, -1) // Remove the last full or partial word
                .join(" ") + afterText; // Combine into a single string and append the afterText

            // Append the truncated text
            if ( $(this).text().length <= charLimit ) {
                return;
            } else {
                $(this).text( shortText );
            }
        });
    },

    detectBrowser : function(selector){
        var selector = selector || 'html',
            ua = navigator.userAgent,
            browser = '',
            versionOffset;

        // In Opera, the true version is after "Opera" or after "Version"
        if ( (versionOffset = ua.indexOf("Opera")) != -1 ){
            browser = 'is-opera';
        }
        // In MSIE, the true version is after "MSIE" in userAgent
        else if ( (versionOffset = ua.indexOf("MSIE")) != -1 ){
            browser = 'is-ie';
        }
        // In Chrome, the true version is after "Chrome"
        else if ( (versionOffset = ua.indexOf("Chrome")) !=- 1 ){
            browser = 'is-chrome';
        }
        // In Safari, the true version is after "Safari" or after "Version"
        else if ( (versionOffset = ua.indexOf("Safari")) != -1 ){
            browser = 'is-safari';
        }
        // In Firefox, the true version is after "Firefox"
        else if ( (versionOffset = ua.indexOf("Firefox")) != -1 ){
            browser = 'is-firefox';
        }

        if ( browser.length > 0 ) $(selector).addClass(browser);
    },

    isMobile : function(){
        return (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()));
    },

    counter : function(selector, start, complete, duration, roundUp){
        var start = start || 0,
            duration = duration || 1500,
            roundUp = roundUp || false;

        $({ counter : start }).animate({ counter : complete }, {
            duration : duration,
            // for each step, update the number
            step : function(){
                var number = roundUp ? Math.ceil(this.counter) : this.counter.toFixed(2);

                $(selector).text(number);
            },
            // on complete make sure we make it show the number we calculated
            complete : function(){
                var number = roundUp ? Math.ceil(this.counter) : this.counter.toFixed(2);

                number = QGIV.Utilities.numberWithCommas(number);

                $(selector).text(number);
            }
        });
    },

    displayStat : function(selector, value, roundUp){
        var roundUp = roundUp || false,
            number = roundUp ? Math.ceil(value) : value.toFixed(2);

        number = QGIV.Utilities.numberWithCommas(number);

        $(selector).text(number);
    },

    initColorpicker : function(){
        if ( $('.ui-colorpicker').length && $.fn.colpick ){
            // bind colorpicker clickout
            $('.is-colorpicker').off('click').on('click', function(){
                $('.swatch-container .colpick').hide();
                var colorpicker = $(this).next('.ui-colorpicker').find('.colpick');

                colorpicker.fadeToggle(300);

                UI.bindClickOut('.ui-colorpicker', function(selector){
                    if(colorpicker.is(':visible')){
                        colorpicker.find('.colpick_submit').trigger('click');
                        colorpicker.fadeOut(300);
                    }
                });
            });

            $('.ui-colorpicker').each(function(){
                var color = $(this).next('.colorpicker-value').val();
                if (color) {
                    var $swatch_container = $(this).closest('.swatch-container');
                    $swatch_container.find('.swatch').css('background-color', color);
                }
                $(this).colpick({
                    flat : true,
                    layout : 'hex',
                    color : color,
                    onChange : function(hsb, hex, rgb, el, bySetColor){
                        var color = '#' + hex,
                            $swatch_container = $(el).closest('.swatch-container');

                        $swatch_container.find('.swatch').css('background-color', '#' + hex);
                        $swatch_container.find('.colorpicker-value').val(color);
                        $swatch_container.find('.colpick_selector_outer').removeClass('hide-content');
                    },
                    onSubmit : function(hsb, hex, rgb, el){
                        var color = '#' + hex,
                            $swatch_container = $(el).closest('.swatch-container'),
                            $swatch_value = $swatch_container.find('.colorpicker-value');

                        if ( $swatch_value.val() !== 'transparent' ){
                            $swatch_container.find('.swatch').css('background-color', color).removeClass('is-transparent');
                            $swatch_container.find('.colpick_transparency').removeClass('is-selected');
                            $swatch_value.val(color).trigger('change');
                            $(el).find('.colpick').fadeOut(300);
                        }
                    }
                });

                $(this).find('.colpick').hide();
            });
        }
    },

    // Binds event listeners to recurring option els
    // corresponds with markup in /templates/admin/partials/settings_recurring.html
    initRecuringSettingsUi : function() {
        // update the Default Recurring Frequency dropdown when the recurring option checkbox is changed
        $('.js-recurring-option').on('change', function(e) {
            var recurringValue = $(this).val();
            // if the recurring option is checked, enable it in the Default dropdown
            if ( $(this).is(':checked') ) {
                $('.js-default-recurring[value=' + recurringValue + ']').prop('disabled', false);
            } else {
                // if the recurring option is unchecked, disable it from the Default dropdown
                // if the recurring option happens to be selected in the Default dropdown, select the first available enabled option
                if ( $('.js-default-recurring:selected').val() === recurringValue ) {
                    $('.js-default-recurring:enabled').eq(0).prop('selected', true);
                }
                $('.js-default-recurring[value=' + recurringValue + ']').prop('disabled', true).prop('selected', false);
            }
            // ensure that if the selected option is disabled or undefined, we switch it to something enabled if possible
            if ( $('.js-default-recurring:selected').is(':disabled') || $('.js-default-recurring:selected').val() === undefined ) {
                $('.js-default-recurring:enabled').eq(0).prop('selected', true);
            }

            $( '#default-recurring-frequency' ).trigger( 'blur' );
        });
    },

    /**
     * @function upsellTrackingAnalyticsCall
     * @description makes analytics call for any upsell buttons clicked
     * @param {jQuery} $upsellLink the upsell button being clicked
     */
    upsellTrackingAnalyticsCall: function($upsellLink) {
        QGIV.Analytics.Segment.track("Clicked Add Package Button", {
            category : "In-Product Marketing",
            label : $upsellLink.attr('data-analytics-label')
        });
    }
};

var UI = new Interface();
